<template lang="pug">
#projetsetup
  .left
    ul
      li(v-for="item in leftlist", :class="{ active: item === currentNavItem }", :key="item.key", @click="changeli(item)")
        icon-svg(:name="item.key")
        span {{ item.name }}
  .line
  .right
    .rightTop(v-if="!inRole")
      span.title {{ title }}
      span.tipe(v-if="inDirectory && fabutipsshow") 当前版本尚未发布!
    div(:class="[{ rightContent: !inRole }]", style="height: 100%")
      router-view
</template>

<script>
import { mapState } from "vuex";
import keyCatalog from "@/CommonDP/service/folder-service";
const req = require.context("./icon-svg/", false, /\.svg$/);
req.keys().forEach(req);
const navigation = [
  {
    name: "关键目录维护",
    key: "directoryMaintenance"
  },
  {
    name: "角色权限管理",
    key: "rolePermission"
  },
  {
    key: "revitBanbenshezhi",
    name: "Revit版本设置"
  },
  {
    key: "yangbanshezhi",
    name: "样板设置"
  },
  {
    key: "banbenshezhi",
    name: "标准图框设置"
  }
];
export default {
  name: "Setup",
  data() {
    return {
      radio: "",
      fabutipsshow: false
      // 先判断有没有发布过 如果没有发布过 就一直存在 如果发布过 增删改查启用禁用上移下移都变false
    };
  },
  computed: {
    ...mapState({
      flatProjectRoutes: (state) => state.router.flatProjectRoutes,
      prjInfo: (state) => state.projectMg.prjObj,
      catalogInit: (state) => state.projectMg.catalogInit
    }),
    leftlist() {
      const { flatProjectRoutes } = this;
      return navigation.filter(({ key }) => flatProjectRoutes.some(({ permissionKey }) => key === permissionKey));
    },
    currentNavItem() {
      const name = this.$route.name;
      return navigation.find(({ key }) => key === name) || {};
    },
    title() {
      return this.currentNavItem?.name;
    },
    inRole() {
      return this.currentNavItem.key === "rolePermission";
    },
    inDirectory() {
      return this.currentNavItem.key === "directoryMaintenance";
    }
  },
  created() {
    this.queryfabutips("1");
  },
  methods: {
    async queryfabutips(type) {
      // 发布过
      if (this.catalogInit === "1") {
        if (type === "1") {
          const res = await keyCatalog.queryKeyCatalogList({ prjId: this.prjInfo.prjId });
          if (res.data.directoryStatus === "2") {
            this.fabutipsshow = false;
          } else if (res.data.directoryStatus === "1") {
            this.fabutipsshow = true;
          }
        } else {
          this.fabutipsshow = true;
        }
      } else {
        this.fabutipsshow = true;
      }
    },
    async changeli(item) {
      const prjId = this.prjInfo.prjId;
      if (item.name === "角色权限管理") {
        this.$router.push({ name: item.key });
        const res = await keyCatalog.checkCatalogIsInit({ prjId });
        this.$store.dispatch("setCatalogToken", res.data ? "1" : "0");
        if (!res.data) this.$router.push({ name: "catalogInit" });
      } else if (item.name === "关键目录维护") {
        this.$router.push({ name: item.key });
        this.queryfabutips("1");
      } else {
        this.$router.push({ name: item.key });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
#projetsetup {
  width: 100%;
  height: 100%;
  .left {
    position: absolute;
    width: 235px;
    height: 100%;
    background: $--color-white;
    border-radius: 4px;
    ul {
      margin-top: var(--middle-space);
    }
    li {
      text-align: left;
      cursor: pointer;
      height: 38px;
      line-height: 36px;
      margin-bottom: var(--middle-space);
      .icon-svg {
        font-size: 16px;
        width: 24px;
        display: inline-block;
        color: $--color-primary;
        vertical-align: middle;
        margin: 0 3px 0 28px;
      }
      span {
        vertical-align: middle;
      }
    }
    .active {
      background: rgba($--color-primary, 0.08);
    }
  }
  .line {
    left: 235px;
    width: 13px;
    height: 100%;
    position: absolute;
    background: mix($--color-primary, $--color-white, 0.1);
  }
  .right {
    left: 248px;
    height: 100%;
    background: #fff;
    width: calc(100% - 248px);
    position: absolute;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 16px;
      color: #333;
      font-weight: 600;
    }
    .tipe {
      color: $--color-danger;
      font-size: 14px;
      margin-left: 12px;
    }
    .rightTop {
      border-bottom: 1px solid #ebefff;
      padding: var(--middle-space) var(--big-space);
    }
    .rightContent {
      padding: var(--middle-space) var(--big-space);
      height: 1px;
      flex-grow: 1;
    }
  }
}
</style>
